@if ((content && items?.length && items[0].image) || client.isCms) {
<div class="w-12 p-t-12-x p-t-12-l p-b-12-x p-b-12-l"
     [ngClass]="content?.styles?.bg ? 'bg-' + content?.styles?.bg : ''">
    <div class="wrap-x wrap-l">
        <div [grid]="3"
             [gridColumnGap]="2"
             *ifSize="'XL'">
            @for (item of items; track item) {
            <div class="w-12">
                <div class="ratio-1-1">
                    @if (item.image) {
                    <img [image]="item.image"
                         class="rf">
                    }
                </div>

                <div class="p-l-2 p-t"
                     *ngIf="items?.length === 3">
                    <h3 class="h3"
                        [ngClass]="content?.titleColor || 'col-1'">
                        {{item.title}}
                    </h3>

                    <p class="m-t-2 p1"
                       [ngClass]="content?.descColor || 'col-1'"
                       [innerHtml]="item?.desc">
                    </p>
                </div>
            </div>
            }

            <div class="w-12 p-b-8 flex flex-column flex-justify-center"
                 [gridColumn]="items?.length === 1 ? 2 : undefined"
                 *ngIf="items?.length !== 3">
                @for (item of items; track item) {
                <div class="p-l p-t-6">
                    <h3 class="h3"
                        [ngClass]="content?.titleColor || 'col-1'">
                        {{item.title}}
                    </h3>

                    <p class="m-t-2 p1"
                       [ngClass]="content?.descColor || 'col-1'"
                       [innerHtml]="item?.desc">
                    </p>
                </div>
                }
            </div>
        </div>

        <div *ifSize="'SM'">

            @switch (items?.length) {
                @case (1) {
                <div class="ratio-1-1">
                    <img [image]="items[0].image"
                         class="rf">
                </div>

                <div class="p-l-2 p-t-2 p-b-2">
                    <h3 class="h4"
                        [ngClass]="content?.titleColor || 'col-1'">
                        {{items[0].title}}
                    </h3>

                    <read-more class="block m-t-1 p1"
                               [ngClass]="content?.descColor || 'col-11'"
                               [text]="items[0].desc"
                               [limit]="'77'"
                               readMore="...read more"
                               readLess="...read less"
                               [mobileReadMoreColor]="content?.descColor || 'col-11'"
                               [showIcon]="false">
                    </read-more>
                </div>
                }

                @default {
                <carousel [slidesPerView]="1.25"
                          [spaceBetween]="15">
                    @for (item of items; track item) {
                    <ng-template swiperSlide>
                        <div class="ratio-1-1">
                            <img [image]="item.image"
                                 class="rf">
                        </div>

                        <div class="p-l-2 p-t p-b">
                            <h3 class="h4"
                                [ngClass]="content?.titleColor || 'col-1'">
                                {{item.title}}
                            </h3>

                            <read-more class="block m-t-2 p1"
                                       [ngClass]="content?.descColor || 'col-11'"
                                       [text]="item.desc"
                                       [limit]="'68'"
                                       readMore="...read more"
                                       readLess="...read less"
                                       [mobileReadMoreColor]="content?.descColor || 'col-11'"
                                       [showIcon]="false">
                            </read-more>
                        </div>
                    </ng-template>
                    }
                </carousel>
                }
            }
        </div>
    </div>
</div>
}